export default "__VITE_ASSET__DRL0F2qo__"